import platformBackendClient from '@backend-clients/platform-backend';
import cypressAccess from '@utils/cypress-access';

const state = {
  test: false,
  verification: {},
  verifying: false,
  loading: false,
  errors: {
    code: '',
  },
};

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const getters = {
  testAuthEndpoint: (state) => state.test,
  currentVerification: (state) => state.verification,
  verifyingCode: (state) => state.verifying,
  loadingVerification: (state) => state.loading,
  authenticationErrors: (state) => state.errors,
};

const actions = {
  testVerifications({ commit }) {
    return new Promise((resolve, reject) => {
      platformBackendClient.get('/api/auth/two-factor/test')
        .then((res) => {
          commit('test_verifications');
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  clearAuthenticationErrors({ commit }) {
    commit('authentication_error', [
      {
        key: 'code',
        message: '',
      },
    ]);
  },
  setAuthenticationError({ commit }, error) {
    commit('authentication_error', error);
  },
  getVerification({ commit }, payload) {
    // Uses 'sid' to search for the verification details
    commit('loading_verification');
    return new Promise((resolve, reject) => {
      platformBackendClient.get(`/api/auth/${payload.verification}/${payload.sid}`)
        .then((res) => {
          resolve(res);
          commit('fetch_verification', res.data);
        })
        .catch((err) => {
          reject(err);
          commit('finish_loading_verification');
        });
    });
  },
  createVerification({ commit }, payload) {
    // Uses 'uid' to search for user's phone number, verifies the number
    // and turns it into E.164 format. It then sends the verification code
    // through SMS or email.
    const { channel } = payload;

    return new Promise((resolve, reject) => {
      platformBackendClient.post(`/api/auth/${payload.verification}/${payload.uid}`, { channel, cypress_bypass: cypressAccess() })
        .then((res) => {
          resolve(res);
          commit('set_verification', res.data);
        })
        .catch((err) => reject(err));
    });
  },
  updateVerification({ commit }, payload) {
    // Updates the status of the verification
    return new Promise((resolve, reject) => {
      platformBackendClient.put(`/api/auth/${payload.verification}/${payload.sid}`)
        .then((res) => {
          resolve(res);
          commit('set_verification', res.data);
        })
        .catch((err) => reject(err));
    });
  },
  verifyPasswordResetCode({ commit }, payload) {
    commit('verifying_code', true);
    return new Promise((resolve, reject) => {
      platformBackendClient.post(`/api/auth/${payload.verification}/verify/${payload.uid}`, { code: payload.code })
        .then((res) => {
          commit('verifying_code', false);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
};

const mutations = {
  test_verifications: (state) => { state.test = true; },
  authentication_error: (state, errors) => {
    /*
      [
        {
          key: 'code',
          message: 'asdf',
        }
      ]
    */
    errors.forEach((error) => {
      state.errors[error.key] = error.message;
    });
  },
  loading_verification: (state) => { state.loading = true; },
  verifying_code: (state, verifying) => { state.verifying = verifying; },
  fetch_verification: (state, verification) => {
    state.verification = verification;
    state.loading = false;
  },
  set_verification: (state, verification) => {
    state.verification = verification;
    if (state.loading) state.loading = false;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
